import { handleApiError } from './notificationActions';
import { FetchAvailableTickers } from "../Apis/FetchAvailableTickers";
import pako from "pako";

export const FETCH_AVAILABLE_TICKERS_START = 'FETCH_AVAILABLE_TICKERS_START';
export const FETCH_AVAILABLE_TICKERS_SUCCESS = 'FETCH_AVAILABLE_TICKERS_SUCCESS';
export const FETCH_AVAILABLE_TICKERS_FAILURE = 'FETCH_AVAILABLE_TICKERS_FAILURE';

export const fetchAvailableTickers = () => async (dispatch) => {
    return new Promise(async (resolve, reject) => {
        dispatch({ type: FETCH_AVAILABLE_TICKERS_START });
        try {
            const today = new Date().toISOString().split('T')[0];
            const response = await FetchAvailableTickers();
            if(response.status === 200){
                const binaryString = atob(response.result);
                const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
                const decompressed = pako.ungzip(byteArray, { to: "string" });
                const decodedData = JSON.parse(decompressed);
                dispatch({ 
                    type: FETCH_AVAILABLE_TICKERS_SUCCESS, 
                    payload: {  
                        details: decodedData, 
                        fetchedDate: today
                    } 
                });
                resolve(decodedData);
            } else {
                handleApiError(response, dispatch);
                reject(response);
            }
        } catch (error) {
            dispatch({ 
                type: FETCH_AVAILABLE_TICKERS_FAILURE, 
                payload: {error: error.toString() } 
            });
            reject(error);
        }
    });
};


// export const fetchAvailableTickers = () => async (dispatch) => {
//     dispatch({ type: FETCH_AVAILABLE_TICKERS_START });

//     try {
//         const response = await FetchAvailableTickers();
//         if(response.status === 200){
//             dispatch({ 
//                 type: FETCH_AVAILABLE_TICKERS_SUCCESS, 
//                 payload: {  
//                     details: response.result, 
//                 } 
//             });
//         }else{
//             handleApiError(response, dispatch);
//         }
//     } catch (error) {
//         dispatch({ 
//             type: FETCH_AVAILABLE_TICKERS_FAILURE, 
//             payload: {error: error.toString() } 
//         });
//     }
//     return Promise.resolve();
// };